<template>
  <div class="p-4 space-y-4">
    <!-- Encabezado -->
    <div class="flex items-center justify-between">
      <div>
        <h1 class="text-xl font-bold text-gray-900 dark:text-gray-100">Categorías Financieras</h1>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Administra las categorías de ingresos y egresos</p>
      </div>
      <button
        @click="abrirModalNueva"
        class="px-3 py-1.5 text-sm font-medium rounded-md bg-violet-600 text-white hover:bg-violet-700 transition-colors flex items-center gap-1.5"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
        Nueva Categoría
      </button>
    </div>

    <!-- Filtro por tipo -->
    <div class="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-800 p-4">
      <div class="flex items-center gap-4">
        <label class="text-sm font-medium text-gray-700 dark:text-gray-300">Tipo:</label>
        <div class="flex gap-2">
          <button @click="filtroTipo = null; cargarCategorias()" :class="filtroTipo === null ? 'bg-violet-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'" class="px-3 py-1.5 text-sm rounded-md hover:bg-violet-700 hover:text-white transition">
            Todas
          </button>
          <button @click="filtroTipo = 'ingreso'; cargarCategorias()" :class="filtroTipo === 'ingreso' ? 'bg-green-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'" class="px-3 py-1.5 text-sm rounded-md hover:bg-green-700 hover:text-white transition">
            Ingresos
          </button>
          <button @click="filtroTipo = 'gasto'; cargarCategorias()" :class="filtroTipo === 'gasto' ? 'bg-red-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'" class="px-3 py-1.5 text-sm rounded-md hover:bg-red-700 hover:text-white transition">
            Egresos
          </button>
        </div>
      </div>
    </div>

    <!-- Estado de carga -->
    <div v-if="cargando && categorias.length === 0" class="text-center py-12">
      <div class="inline-block w-8 h-8 border-4 border-violet-600 border-t-transparent rounded-full animate-spin"></div>
      <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">Cargando categor�as...</p>
    </div>

    <!-- Grid de categor�as -->
    <div v-else-if="categorias.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div
        v-for="categoria in categorias"
        :key="categoria.id"
        class="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-800 p-4 hover:shadow-md transition"
      >
        <div class="flex items-start justify-between">
          <div class="flex items-center gap-3 flex-1">
            <div
              class="w-12 h-12 rounded-lg flex items-center justify-center"
              :style="{ backgroundColor: categoria.color + '20' }"
            >
              <div
                class="w-8 h-8 rounded-full"
                :style="{ backgroundColor: categoria.color }"
              ></div>
            </div>
            <div class="flex-1">
              <h3 class="font-semibold text-gray-900 dark:text-gray-100">{{ categoria.nombre }}</h3>
              <div class="flex items-center gap-2 mt-1">
                <span
                  class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium"
                  :class="categoria.tipo === 'ingreso' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'"
                >
                  {{ categoria.tipo === 'ingreso' ? 'Ingreso' : 'Egreso' }}
                </span>
                <span
                  v-if="!categoria.activa"
                  class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300"
                >
                  Inactiva
                </span>
              </div>
              <p v-if="categoria.descripcion" class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                {{ categoria.descripcion }}
              </p>
            </div>
          </div>
          <div class="flex gap-1">
            <button
              @click="editarCategoria(categoria)"
              class="p-1.5 text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 rounded"
              title="Editar"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </button>
            <button
              @click="eliminarCategoriaConfirm(categoria.id)"
              class="p-1.5 text-gray-600 hover:text-red-600 dark:text-gray-400 dark:hover:text-red-400 rounded"
              title="Eliminar"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Estado vac�o -->
    <div v-else class="text-center py-12 bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-800">
      <svg class="w-16 h-16 mx-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
      </svg>
      <p class="mt-3 text-sm text-gray-500 dark:text-gray-400">No hay categor�as registradas</p>
      <button @click="abrirModalNueva" class="mt-3 px-4 py-2 text-sm font-medium rounded-md bg-violet-600 text-white hover:bg-violet-700">
        Crear primera categor�a
      </button>
    </div>

    <!-- Modal para Nueva/Editar Categor�a -->
    <div v-if="modalAbierto" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" @click.self="cerrarModal">
      <div class="bg-white dark:bg-gray-900 rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div class="sticky top-0 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-gray-100">
            {{ categoriaEditando ? 'Editar Categor�a' : 'Nueva Categor�a' }}
          </h2>
          <button @click="cerrarModal" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <form @submit.prevent="guardarCategoria" class="p-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nombre *</label>
            <input
              v-model="formulario.nombre"
              type="text"
              required
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-violet-500 focus:border-transparent bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100"
              placeholder="Ej: Ventas al por mayor"
            />
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo *</label>
            <select
              v-model="formulario.tipo"
              required
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-violet-500 focus:border-transparent bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100"
            >
              <option value="ingreso">Ingreso</option>
              <option value="gasto">Egreso</option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Color *</label>
            <div class="flex gap-2 flex-wrap">
              <button
                v-for="color in coloresDisponibles"
                :key="color"
                type="button"
                @click="formulario.color = color"
                class="w-10 h-10 rounded-lg border-2 transition"
                :class="formulario.color === color ? 'border-violet-600 ring-2 ring-violet-200' : 'border-gray-300 dark:border-gray-600'"
                :style="{ backgroundColor: color }"
              ></button>
            </div>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Descripci�n</label>
            <textarea
              v-model="formulario.descripcion"
              rows="3"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-violet-500 focus:border-transparent bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100"
              placeholder="Descripci�n opcional..."
            ></textarea>
          </div>

          <div v-if="categoriaEditando" class="flex items-center">
            <input
              v-model="formulario.activa"
              type="checkbox"
              id="activa"
              class="w-4 h-4 text-violet-600 border-gray-300 rounded focus:ring-violet-500"
            />
            <label for="activa" class="ml-2 text-sm text-gray-700 dark:text-gray-300">Categor�a activa</label>
          </div>

          <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
            <button
              type="button"
              @click="cerrarModal"
              class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700"
            >
              Cancelar
            </button>
            <button
              type="submit"
              :disabled="cargando"
              class="px-4 py-2 text-sm font-medium text-white bg-violet-600 rounded-md hover:bg-violet-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              <span v-if="cargando" class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
              {{ categoriaEditando ? 'Actualizar' : 'Guardar' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import categoriasServicio from '@/services/finanzas/categoriasServicio'
import Swal from 'sweetalert2'

const categorias = ref([])
const cargando = ref(false)
const modalAbierto = ref(false)
const categoriaEditando = ref(null)
const filtroTipo = ref(null)

const formulario = ref({
  nombre: '',
  tipo: 'ingreso',
  color: '#10B981',
  descripcion: '',
  activa: true
})

const coloresDisponibles = [
  '#10B981', // green
  '#3B82F6', // blue
  '#8B5CF6', // violet
  '#EF4444', // red
  '#F59E0B', // amber
  '#EC4899', // pink
  '#6366F1', // indigo
  '#14B8A6', // teal
  '#F97316', // orange
  '#06B6D4', // cyan
  '#84CC16', // lime
  '#64748B'  // slate
]

const cargarCategorias = async () => {
  cargando.value = true
  try {
    const params = {}
    if (filtroTipo.value) {
      params.tipo = filtroTipo.value
    }
    categorias.value = await categoriasServicio.listar(params)
  } catch (error) {
    Swal.fire('Error', 'No se pudieron cargar las categor�as', 'error')
  } finally {
    cargando.value = false
  }
}

const abrirModalNueva = () => {
  categoriaEditando.value = null
  formulario.value = {
    nombre: '',
    tipo: 'ingreso',
    color: '#10B981',
    descripcion: '',
    activa: true
  }
  modalAbierto.value = true
}

const editarCategoria = (categoria) => {
  categoriaEditando.value = categoria
  formulario.value = {
    nombre: categoria.nombre,
    tipo: categoria.tipo,
    color: categoria.color,
    descripcion: categoria.descripcion || '',
    activa: categoria.activa
  }
  modalAbierto.value = true
}

const cerrarModal = () => {
  modalAbierto.value = false
  categoriaEditando.value = null
}

const guardarCategoria = async () => {
  cargando.value = true
  try {
    if (categoriaEditando.value) {
      await categoriasServicio.actualizar(categoriaEditando.value.id, formulario.value)
      await Swal.fire('�xito', 'Categor�a actualizada correctamente', 'success')
    } else {
      await categoriasServicio.crear(formulario.value)
      await Swal.fire('�xito', 'Categor�a creada correctamente', 'success')
    }
    cerrarModal()
    await cargarCategorias()
  } catch (error) {
    Swal.fire('Error', error.mensaje || 'No se pudo guardar la categor�a', 'error')
  } finally {
    cargando.value = false
  }
}

const eliminarCategoriaConfirm = async (id) => {
  const result = await Swal.fire({
    title: '�Eliminar categor�a?',
    text: 'Solo se pueden eliminar categor�as sin movimientos asociados',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'S�, eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#EF4444'
  })

  if (result.isConfirmed) {
    try {
      await categoriasServicio.eliminar(id)
      await Swal.fire('Eliminada', 'Categor�a eliminada correctamente', 'success')
      await cargarCategorias()
    } catch (error) {
      Swal.fire('Error', error.mensaje || 'No se pudo eliminar la categor�a', 'error')
    }
  }
}

onMounted(async () => {
  await cargarCategorias()
})
</script>
